import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC5INl_hPXo7lnJu5zGNkPY-PeAhekhSbg",
  authDomain: "inmobiliariaplorutti-7aedb.firebaseapp.com",
  projectId: "inmobiliariaplorutti-7aedb",
  storageBucket: "inmobiliariaplorutti-7aedb.firebasestorage.app",
  messagingSenderId: "961287329403",
  appId: "1:961287329403:web:827b3527876d9de12174de",
  measurementId: "G-67ZE98NGGZ",
};

const app = initializeApp(firebaseConfig);

// Inicializa Firestore y Storage pasando la instancia de app
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

export default app;
